
import { useMemo } from 'react';
import useAssets from '../../../hooks/useAssets'
import useSelectedGroupSatellite from '../../../hooks/useSelectedGroupSatellite';
import TimelineFaultEvents from '../../../../../CommonComponents/timeline-fault-events/TimelineFaultEvents';
import { TimelineFaultsContainer } from '../../../../../CommonComponents/timeline/Timeline';

const FaultEvents = () => {
    const { faultPlans } = useAssets()
    const { selectedGroupSatellite } = useSelectedGroupSatellite()

    const selectedSatellite = useMemo(() => selectedGroupSatellite?.satelliteId, [selectedGroupSatellite?.satelliteId])
    const allFaultsReport = useMemo(() => faultPlans.data, [faultPlans.data])
    const faults = useMemo(() => selectedSatellite && allFaultsReport ? allFaultsReport[selectedSatellite]?.faults || [] : [], [selectedSatellite, allFaultsReport])

    return (
        <TimelineFaultsContainer>
            <TimelineFaultEvents faults={faults} />
        </TimelineFaultsContainer>
    )

}

export default FaultEvents